






















































































import {
  SettingManagementCreateSettingRequest,
  SettingManagementEditSettingRequest,
  SettingManagementSettingService,
} from "@/common/api";
import qNotify from "@/common/qNotify";
import QInput from "@/components/common/qInput.vue";
import QTextArea from "@/components/common/qTextArea.vue";
import _ from "lodash";
import { error } from "logrocket";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "SettingEditComponent",
  methods: { error },
  components: { QTextArea, QInput },
})
export default class SettingEditComponent extends Vue {

  get isEditing() {
    return this.dictionary.id !== null;
  }
  public title = "";
  public isShow = false;
  public errors = {};

  @Prop({
    type: Array,
    default: [
      {
        id: SettingManagementCreateSettingRequest.category.BREEDER,
        name: "生産者",
      },
      {
        id: SettingManagementCreateSettingRequest.category.VARIETY,
        name: "品種",
      },
      {
        id: SettingManagementCreateSettingRequest.category.PARENT_CARP,
        name: "親鯉",
      },
      {
        id: SettingManagementCreateSettingRequest.category.NOTE,
        name: "備考",
      },
    ],
  })
  public categories;

  public dictionary = {
    id: null,
    category: SettingManagementEditSettingRequest.category.BREEDER,
    addr: "",
    context: "",
    contextEn: "",
    contextCn: "",
  };

  public origin = {
    id: null,
    category: SettingManagementEditSettingRequest.category.BREEDER,
    addr: "",
    context: "",
    contextEn: "",
    contextCn: "",
  };

  public show(id) {
    this.isShow = true;
    this.errors = {};
    this.dictionary = {
      id: null,
      category: SettingManagementEditSettingRequest.category.BREEDER,
      addr: "",
      context: "",
      contextEn: "",
      contextCn: "",
    };
    this.title = "設定の追加";

    if (id) {
      this.dictionary.id = id;
      this.getDetail(id);
    }
  }

  public async getDetail(id) {
    try {
      const { data } = await SettingManagementSettingService.adminSettingView({
        id,
      });

      this.title = "設定の編集";
      this.dictionary = {
        id: data.setting.id,
        category: data.setting
          .category as SettingManagementEditSettingRequest.category,
        addr: data.setting.addr,
        context: data.setting.context,
        contextEn: data.setting.context_en,
        contextCn: data.setting.context_cn,
      };
      this.origin = {
        ...this.dictionary,
      };
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
      this.isShow = false;
      this.$emit("close");
    }
  }

  public async submit() {
    let result;

    try {
      if (this.isEditing) {
        result = await SettingManagementSettingService.adminSettingEdit(
          this.dictionary,
        );
      } else {
        result = await SettingManagementSettingService.adminSettingCreate(
          this.dictionary,
        );
      }

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        this.isShow = false;
        this.$emit("close");
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public async delete() {
    let result;

    try {
      result = await SettingManagementSettingService.adminSettingDelete({
        id: this.dictionary.id,
      });

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        this.isShow = false;
        this.$emit("close");
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      onConfirm: () => {
        this.delete();
        this.isShow = false;
      },
      onClose: () => {
        //
      },
    });
  }

  public confirmCancel() {
    if (!_.isEqual(this.dictionary, this.origin)) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
        onClose: () => {
          //
        },
      });
    } else {
      this.isShow = false;
    }
  }
}
